import React, { PureComponent, Fragment } from 'react';
import { withNamespaces } from 'react-i18next';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

import NotificationsActiveIcon from '@material-ui/icons/NotificationsActiveOutlined';
import NotificationsOffIcon from '@material-ui/icons/NotificationsOffOutlined';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';

import combineStyles from '../../utils/combineStyles';
import CollapseWrapperStyles from '../../styles/components/collapseWrapper';
import TypographyStyles from '../../styles/typography';
import ButtonStyles from '../../styles/button';
import CommentsSectionStyles from './__styles__/CommentsSection.styles';

import CollapseWrapper from '../Global/CollapseWrapper';

import CommentInput from '../shipment/Comments/CommentInput';
import CommentList from '../shipment/Comments/CommentList';
import AllCommentsModal from '../shipment/Comments/AllCommentsModal';

import {
  comments as mockedComments,
  users as mockedUser
} from './mockedValues';

const MAX_NUMBER_OF_COMMENTS_DISPLAYED = 3;

export class CommentsSection extends PureComponent {
  state = {
    activeNotification: true,
    displayAllComments: false,
    subscribed: true
  };

  _activeNotificationToggle = () =>
    this.setState({ activeNotification: !this.state.activeNotification });

  _toggleAllComments = () =>
    this.setState({ displayAllComments: !this.state.displayAllComments });

  render() {
    const { t, classes } = this.props;
    return (
      <Fragment>
        <CollapseWrapper
          classes={{
            root: classes.root,
            header: classes.panelHeader,
            expandButton: classes.expandButton,
            bodyRoot: classes.collapsePanelBodyRoot
          }}
          header={() => (
            <div className={classes.titleWrapper}>
              <h2 className={classnames(classes.headline8, classes.title)}>
                {t('Comments')} ({mockedComments.length})
              </h2>
              <IconButton
                color="primary"
                onClick={this._activeNotificationToggle}
                className={classes.activateButton}
              >
                {this.state.activeNotification ? (
                  <NotificationsActiveIcon />
                ) : (
                  <NotificationsOffIcon />
                )}
              </IconButton>
            </div>
          )}
          body={
            <Fragment>
              <Divider />
              <CommentInput onSave={() => {}} users={[]} />
              <CommentList
                maxNumberOfComments={MAX_NUMBER_OF_COMMENTS_DISPLAYED}
                comments={mockedComments}
                users={mockedUser}
                onDelete={() => {}}
                onEditClick={() => {}}
              />
              {mockedComments.length > MAX_NUMBER_OF_COMMENTS_DISPLAYED && (
                <div className={classes.body}>
                  <Button
                    variant={'outlined'}
                    className={classnames(classes.button, classes.actionButton)}
                    onClick={this._toggleAllComments}
                    color={'primary'}
                    classes={{ label: classes.buttonLabel }}
                  >
                    {t('View All Comments')}
                  </Button>
                </div>
              )}
            </Fragment>
          }
        />
        <AllCommentsModal
          open={this.state.displayAllComments}
          onClose={this._toggleAllComments}
          comments={mockedComments}
          users={mockedUser}
          onCreate={() => {}}
          onDelete={() => {}}
          onEditClick={() => {}}
          subscribed={this.state.subscribed}
          toggleSubscribe={() => {}}
        />
      </Fragment>
    );
  }
}

export default withStyles(
  combineStyles(
    CommentsSectionStyles,
    ButtonStyles,
    CollapseWrapperStyles,
    TypographyStyles
  )
)(withNamespaces()(CommentsSection));
